<section *ngIf="auxBanners() && auxBanners().length">
  <swiper-container #swiperCSV init="false" class="swiper-container">
    <swiper-slide
      *ngFor="let banner of auxBanners(); index as i"
      [ngClass]="{'cursor-pointer': !isTeamMach(banner)}"
      (click)="clickSlide(banner)"
      class="slots-slider"
    >
      <div class="slider-banner newCarousel">
        <img [src]="!isDesktop ? banner?.bannerMobileImage : banner?.bannerDesktopImage" />
        <codere-slider-container
          *ngIf="banner && canShowContainer(banner)"
          class="newCarouselWrapper"
          [ngClass]="{'ismobile3' : banner?.typeOfTemplate === 'One Odd' && !isDesktop}"
          [slide]="banner"
          (clickedSlide)="listenerContainerEvent($event)"
        ></codere-slider-container>
        <codere-countdown
          *ngIf="canShowCountDown(banner)"
          [dateTime]="banner.countdownEnd"
          (countDownEvent)="countDown = $event"
          [ngStyle]="formatStylesCountdown(banner)"
        >
          <div *ngIf="banner.countdownTitle" class="titlecountdown" [innerHTML]="banner.countdownTitle"></div>
          <codere-countdown-banner-template
            [countDownResult]="countDown"
            [countDownOptions]="banner.countdownFormat | codereCountDownFormat"
          ></codere-countdown-banner-template>
        </codere-countdown>
      </div>
    </swiper-slide>
  </swiper-container>
  <div #bullets class="swiper-pagination-csv"></div>
  <ng-container *ngIf="auxBanners() && auxBanners()?.length > 1 && isDesktop">
    <button #btnprev class="swiper-button-prev-csv slide-control prev" ion-button (click)="btnLeft()">
      <ion-icon name="chevron-back-outline"></ion-icon>
    </button>
    <button #btnext class="swiper-button-next-csv slide-control next" ion-button (click)="btnRight()">
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </button>
  </ng-container>
</section>
